import React, { useMemo, useState, useEffect } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import debounce from "lodash.debounce";
import { X } from "react-feather";

export default function CategoryToolbar({ search, setSearch, onRefetch }) {
  const [searchLoading, setSearchLoading] = useState(false);

  const debouncedSetSearch = useMemo(
    () =>
      debounce((value) => {
        setSearch(value);
        setSearchLoading(false);
      }, 500),
    [setSearch]
  );

  useEffect(() => {
    return () => debouncedSetSearch.cancel();
  }, [debouncedSetSearch]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchLoading(true);
    debouncedSetSearch(value);
  };

  const clearSearch = () => {
    debouncedSetSearch("");
    setSearch("");
    setSearchLoading(false);
  };

  return (
    <div className="page-title-box">
      <div className="page-title-right d-flex align-items-center mb-2 gap-2">
        <Button variant="primary" onClick={onRefetch}>
          <i className="mdi mdi-autorenew" />
        </Button>
      </div>
    </div>
  );
}
